module.exports = __webpack_public_path__ + "media/images/unlikely_smiley-65077fd3dfc0752ebbbc9eedfc6cf160.svg";